export class newnscModel {
    
    "newUserMob" : string = "";
    
  }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/newNSC/new.nsc.model.ts